import React from 'react';
import LsRequestsList from '../../ls-requests/LsRequestsList';

const MyActiveLs = () => {
  return <LsRequestsList />;
};

export default MyActiveLs;
